import { ContactUsActionTypes } from './contactUs.types'

//Send Message
export const contactUsSendMessageRequest = data => ({
    type: ContactUsActionTypes.CONTACT_US_SEND_MESSAGE_REQUEST,
    payload: data
})

export const contactUsSendMessageRequestSuccess = data => ({
    type: ContactUsActionTypes.CONTACT_US_SEND_MESSAGE_REQUEST_SUCCESS,
    payload: data
})

export const contactUsSendMessageRequestError = data => ({
    type: ContactUsActionTypes.CONTACT_US_SEND_MESSAGE_REQUEST_ERROR,
    payload: data
})

export const contactUsSendMessageRequestStatus = data => ({
    type: ContactUsActionTypes.CONTACT_US_SEND_MESSAGE_REQUEST_STATUS,
    payload: data
})

//Message List
export const contactUsMessageListRequest = data => ({
    type: ContactUsActionTypes.CONTACT_US_MESSAGE_LIST_REQUEST,
    payload: data
})

export const contactUsMessageListRequestSuccess = data => ({
    type: ContactUsActionTypes.CONTACT_US_MESSAGE_LIST_REQUEST_SUCCESS,
    payload: data
})

export const contactUsMessageListRequestError = data => ({
    type: ContactUsActionTypes.CONTACT_US_MESSAGE_LIST_REQUEST_ERROR,
    payload: data
})